import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { scrollToBriefingStep } from './briefingStepElementId'
import type { BriefingStep } from './types'

type BriefingRequiredNextBannerProps = {
  idPrefix: string
  title: string
  allCompleteMessage: string
  incompleteMessage: string
  goToStepLabel: string
  firstIncompleteStep: BriefingStep | null
}

export function BriefingRequiredNextBanner({
  idPrefix,
  title,
  allCompleteMessage,
  incompleteMessage,
  goToStepLabel,
  firstIncompleteStep,
}: BriefingRequiredNextBannerProps) {
  if (firstIncompleteStep == null) {
    return (
      <Alert variant='info'>
        <AlertTitle className='line-clamp-none'>{title}</AlertTitle>
        <AlertDescription>
          <p>{allCompleteMessage}</p>
        </AlertDescription>
      </Alert>
    )
  }

  return (
    <Alert variant='info'>
      <AlertTitle className='line-clamp-none'>{title}</AlertTitle>
      <AlertDescription className='space-y-3'>
        <p>{incompleteMessage}</p>
        <Button
          type='button'
          variant='outline'
          size='sm'
          aria-label={goToStepLabel}
          onClick={() => {
            scrollToBriefingStep(idPrefix, firstIncompleteStep.key)
          }}
        >
          {goToStepLabel}
        </Button>
      </AlertDescription>
    </Alert>
  )
}
